"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _PaymentCalculatorModalModule = _interopRequireDefault(require("./PaymentCalculatorModal.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _percentIcon = _interopRequireDefault(require("@wisetack/assets/img/percent-icon.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PaymentCalculatorModal = function PaymentCalculatorModal() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal fade", _PaymentCalculatorModalModule["default"].modal),
    id: "paymentCalculatorModal",
    tabIndex: "-1",
    role: "dialog",
    "aria-labelledby": "calculatorLabel",
    "aria-hidden": "false"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-dialog", _PaymentCalculatorModalModule["default"].modalDialog),
    role: "document"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-content", _PaymentCalculatorModalModule["default"].modalContent)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "close",
    "data-test-id": "close-paymentCalculatorModal",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _PaymentCalculatorModalModule["default"].close,
    "aria-hidden": "true"
  }, "\xD7"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-body", _PaymentCalculatorModalModule["default"].modalBody)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: _PaymentCalculatorModalModule["default"].logo,
    src: _percentIcon["default"],
    alt: "bank-logo"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, "Interest Rate (APR)"), /*#__PURE__*/_react["default"].createElement("div", null, "Rates vary between 0% and 29.9% and are subject to customers\u2019 credit at\xA0time\xA0of\xA0application.")))));
};

var _default = PaymentCalculatorModal;
exports["default"] = _default;